import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { isAuthenticated } from './utils/api';
import HomePage from './pages/HomePage';
import DealersPage from './pages/DealersPage';
import LoginPage from './pages/admin/LoginPage';
import AdminLayout from './pages/admin/AdminLayout';
import DashboardPage from './pages/admin/DashboardPage';
import ContactsPage from './pages/admin/ContactsPage';
import BatchesPage from './pages/admin/BatchesPage';
import DealersAdminPage from './pages/admin/DealersAdminPage';
import SettingsPage from './pages/admin/SettingsPage';

// ========== 路由守卫 ==========

/**
 * 管理后台认证守卫
 * 未登录时重定向到 /admin/login
 */
const AdminGuard: React.FC = () => {
  if (!isAuthenticated()) {
    return <Navigate to="/admin/login" replace />;
  }
  return <Outlet />;
};

// ========== 主应用 ==========

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <Routes>
        {/* 用户端路由 */}
        <Route path="/" element={<HomePage />} />
        <Route path="/dealers" element={<DealersPage />} />

        {/* 管理员登录（无需认证） */}
        <Route path="/admin/login" element={<LoginPage />} />

        {/* 管理后台路由（需要认证） */}
        <Route element={<AdminGuard />}>
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<Navigate to="/admin/dashboard" replace />} />
            <Route path="dashboard" element={<DashboardPage />} />
            <Route path="contacts" element={<ContactsPage />} />
            <Route path="batches" element={<BatchesPage />} />
            <Route path="dealers" element={<DealersAdminPage />} />
            <Route path="settings" element={<SettingsPage />} />
          </Route>
        </Route>

        {/* 404 兜底 */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
